import { isEqual } from 'lodash';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { type OrdersState } from '~/reducers/orders';

/**
 * This function is to determine if we should show the loader (saved icon) for updating a parcel
 * or not. Updating a parcel may happen from the side panel and the table quick select action.
 * In case of the quick select, we don't want to show the loader in the side panel.
 * The action to update parcel is ORDERS_UPDATE_PARCEL
 * This action has a set of orders to update in orderSelection which is ordersToUpdate
 * We need to check if any of the ordersToUpdate is in the selectedOrders
 * If yes, then we show the loader
 * If no, then we don't show the loader
 * https://shippo.atlassian.net/browse/ENG-43308
 
 * @param state
 * @param action
 * @returns boolean
 */
export const isUpdatingParcel = (state: OrdersState, action: ActionTypes) => {
  if (action.type === ActionKeys.ORDERS_UPDATE_PARCEL) {
    const { orderSelection: ordersToUpdate } = action.payload;
    const { selectedOrders } = state;
    const orderIds = Object.keys(ordersToUpdate);
    for (let i = 0; i < orderIds.length; i++) {
      if (
        selectedOrders[orderIds[i]] &&
        isEqual(selectedOrders[orderIds[i]], ordersToUpdate[orderIds[i]])
      )
        return true;
    }
  }
  return false;
};
